var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle481Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 264,
    viewBox: "0 0 209 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 41.9121C2 40.2733 2.64649 38.7988 3.80818 37.8174C13.2304 29.8572 49.4618 2.66761 105.303 2.0113C161.368 1.35237 196.505 29.7214 205.365 37.8059C206.423 38.771 207 40.1656 207 41.722V237.119C207 239.712 205.372 241.962 202.947 242.72C186.727 247.787 138.356 261.963 105.278 262C71.6571 262.037 22.4719 247.776 6.06955 242.706C3.63592 241.954 2 239.701 2 237.099V41.9121Z",
    fill: "#DFEAED",
    stroke: "#F65623",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle481Error);
export default __webpack_public_path__ + "static/media/Rectangle 481 Error.a076cc129560889c92c1288133238569.svg";
export { ForwardRef as ReactComponent };